module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否删除这条评论?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makesure()
      }
    }
  }, [_vm._v("确 定")])], 1)])]), _vm._v(" "), _c('div', [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "40px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "33.5%",
      "display": "flex"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品名称：",
      "maxlength": "20"
    },
    model: {
      value: (_vm.goodsName),
      callback: function($$v) {
        _vm.goodsName = $$v
      },
      expression: "goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.findshop()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "region"
  }, [_vm._v("评论管理")]), _vm._v(" "), _c('div', [
    [_c('el-table', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "data": _vm.goodListInfo,
        "stripe": "",
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "CommentatorName",
        "label": "评论用户",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.CommentatorName
            }
          }, [_vm._v(_vm._s(scope.row.CommentatorName))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "UserType",
        "label": "用户身份",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.UserType
            }
          }, [_vm._v(_vm._s(scope.row.UserType))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "FullGoodsName",
        "label": "评论商品",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.FullGoodsName
            }
          }, [_vm._v(_vm._s(scope.row.FullGoodsName))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "CContent",
        "align": "center",
        "width": "",
        "label": "评论内容"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.CContent
            }
          }, [_vm._v(_vm._s(scope.row.CContent))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "CTime",
        "align": "center",
        "label": "评论时间"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.CTime
            }
          }, [_vm._v(_vm._s(scope.row.CTime))])]
        }
      }])
    }), _vm._v(" "), (_vm.BbId == 1 || _vm.userType == 5) ? _c('el-table-column', {
      attrs: {
        "prop": "BrandName",
        "align": "center",
        "width": "100",
        "label": "操作",
        "fixed": "right"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.deleteBut(scope)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-delete"
          }), _vm._v("\n                      删除\n                ")])]
        }
      }], null, false, 3448638004)
    }) : _vm._e()], 1)]
  ], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bfb6060!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/goodscomment.vue
// module id = 1696
// module chunks = 3